const Footer = () => {
	return <div className='absolute bottom-4 right-4 text-white text-xs opacity-50'>© 2024 JC</div>;
};

export default Footer;
